module.exports = __webpack_public_path__ + "img/1.15d413ae.png";